import { Box, Button, ButtonGroup } from "@chakra-ui/react";
import React from "react";
import { Field, Form } from "react-final-form";
import {
  DropzoneControl,
  InputControl,
  MultiLanguageInputControl,
  MultiLanguageTextareaControl,
  Optional,
} from "../components/Form";
import { Media, useCountriesQuery } from "../graphql";

interface MultiLangString {
  sq: string;
  mk: string;
  en: string;
}

export interface ICreateBenefitValues {
  title: MultiLangString;
  description: MultiLangString;
  externalURL?: string;
  externalUrlLabel?: MultiLangString;
  image: Media;
}

interface IBenefitForm {
  onSubmit: (values: ICreateBenefitValues) => void;
  initialValues?: Optional<ICreateBenefitValues>;
}

export const BenefitForm: React.FC<IBenefitForm> = ({
  onSubmit,
  initialValues,
}) => {
  const { data, loading } = useCountriesQuery();
  const validate = (values) => {
    const errors: { [key: string]: string } = {};

    if (!values.title) {
      errors.title = "Fushë e detyruar";
    }

    if (!values.title?.sq || !values.title?.en || !values.title?.mk) {
      errors.title = "Fushë e detyruar";
    }

    if (!values.description) {
      errors.description = "Fushë e detyruar";
    }

    if (
      !values.description?.sq ||
      !values.description?.en ||
      !values.description?.mk
    ) {
      errors.description = "Fushë e detyruar";
    }

    if (!values.image?.key) {
      errors.image = "Fushë e detyruar";
    }

    if (values.externalURL && !values.externalUrlLabel?.sq) {
      errors.externalUrlLabel = "Fushë e detyruar";
    }

    return errors;
  };

  return (
    <Form
      onSubmit={onSubmit}
      validate={validate}
      initialValues={initialValues}
      render={({
        handleSubmit,
        form,
        errors,
        submitting,
        pristine,
        values,
      }) => (
        <Box as="form" p={2} onSubmit={handleSubmit}>
          <MultiLanguageInputControl name="title" label="Titulli" />
          <MultiLanguageTextareaControl name="description" label="Përshkrimi" />
          <DropzoneControl name="image" label="Figura" />
          <InputControl type="text" name="externalURL" label={"Adresa"} />
          <MultiLanguageTextareaControl
            name="externalUrlLabel"
            label="Teksti i butonit së adresës"
          />

          <ButtonGroup spacing={4}>
            <Button
              isLoading={submitting}
              loadingText="Duke dërguar"
              variantColor="teal"
              type="submit"
            >
              Ruaj
            </Button>
            <Button
              variantColor="teal"
              variant="outline"
              onClick={form.reset}
              isDisabled={submitting || pristine}
            >
              Pastro
            </Button>
          </ButtonGroup>
        </Box>
      )}
    />
  );
};
